module.exports = __webpack_public_path__ + "media/offers/offer-poziom-color-d2093b44.png";